import { DeleteUserBase } from "../DeleteUserBase";

/**
 * Delete a manager.
 */
export const DeleteManager = () => (<DeleteUserBase defaultRoleGroup={'Driver manager'} />);
